import {AxiosProgressEvent} from 'axios';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostUploadFilePreview,
	PostUploadFilePreviewResponse,
	PostUploadFilePreviewParams,
} from 'domain/usecases/private/refund/request-preview';

export class RemotePostUploadFilePreview implements PostUploadFilePreview {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostUploadFilePreviewResponse>,
		private readonly onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
	) {}

	async post(params: PostUploadFilePreviewParams): Promise<PostUploadFilePreviewResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
			headers: {
				'Content-Type': 'multipart/form-data',
			},
			responseType: 'json',
			onUploadProgress: this.onUploadProgress,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
